;(function(){
    // const base = 'https://goldfish-app-tma6l.ondigitalocean.app';
    const base = 'http://localhost:8080';

    const cssLoaded = new Set()
    function loadCss(name){
        if(cssLoaded.has(name)) return
        cssLoaded.add(name)
        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.href = `${base}/static/dist/css/app.css`
        document.head.appendChild(link)
    }

    function qs(params){
        return Object.entries(params)
            .map(([k,v])=>`${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
            .join('&')
    }

    function inject(el){
        const name  = el.dataset.mfe
        const theme = el.dataset.theme || 'light'
        loadCss(name)
        fetch(`${base}/components/${name}?theme=${theme}`)
            .then(r=>r.ok? r.text(): Promise.reject(r.statusText))
            .then(html=>{
                const tmp = document.createElement('div')
                tmp.innerHTML = html
                el.replaceWith(tmp.firstElementChild)
            })
            .catch(err=>console.error('MFE load error:', err))
    }

    document.addEventListener('DOMContentLoaded', ()=>{
        // 1️⃣ HTMX users embed with hx-get / hx-swap
        //    so loader.js does nothing for elements with hx-get
        // 2️⃣ Otherwise, pick up data-mfe placeholders:
        document
            .querySelectorAll('[data-mfe]')
            .forEach(inject)
    })
})();